export const OOGY_DATA_CDN_URL = window.location.hostname.includes('dev-') || window.location.hostname.includes('localhost') ? 'https://cdn.piratesquadnft.com/clients/oogy-blast/game/data-dev' : 'https://cdn.piratesquadnft.com/clients/oogy-blast/game/data'
export const OOGY_VISUAL_CDN_URL = 'https://cdn.piratesquadnft.com/clients/oogy-blast/game/visual'
export const OOGY_ANIM_CDN_URL = 'https://cdn.piratesquadnft.com/clients/oogy-blast/game/visual/animations'
export const OOGY_SOUND_CDN_URL = 'https://cdn.piratesquadnft.com/clients/oogy-blast/game/sound'

// Game

export const LEVEL_UI_PADDING = 15